import { styled } from "../../../styled-components";
import ReactPlayer from "react-player";

export const Wrapper = styled.div`
    position: relative;
    width: 100%;
    height: ${p => p.theme.youtube.defaultHeight}px;
`;

export const Player = styled(ReactPlayer)`
    position: absolute;
    left: 0;
    right: 0;
    width: 100%;
    height: 100%;
    background-color: black;
`;
